import { css } from '@emotion/core';
import { MediaQueries } from '../../../styles/Grid';
import { colorsPalette } from '../../../styles/colors';
import {
  NAV_MAX_HEIGHT,
  NAV_MAX_HEIGHT_SMALL_VIEWPORT,
} from '../../../utils/constants';

export const navCss = css({
  padding: '10px 0',
  maxHeight: NAV_MAX_HEIGHT_SMALL_VIEWPORT,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  [MediaQueries.md]: {
    padding: '34px 0',
    maxHeight: NAV_MAX_HEIGHT,
  },
  [MediaQueries.lg]: {
    padding: '34px 0',
    maxHeight: NAV_MAX_HEIGHT,
  },
  [MediaQueries.xl]: {
    padding: '34px 0',
    maxHeight: NAV_MAX_HEIGHT,
    position: 'relative',
  },
});

export const navContainerCss = css({
  zIndex: 3,
  backgroundColor: colorsPalette.white,
});

export const darkMode = {
  backgroundColor: colorsPalette.black,
  color: colorsPalette.white,
  justifyContent: 'flex-end',
  [MediaQueries.lgAndUp]: {
    justifyContent: 'space-between',
  },
};

export const containerModalCss = css({
  height: '100%',
});

export const modalRowSearchCss = css({
  height: `calc(100% - ${NAV_MAX_HEIGHT}px)`,
  [MediaQueries.mdAndUp]: {
    alignItems: 'center',
  },
});

export const rowModalCss = css({
  height: `calc(100% - ${NAV_MAX_HEIGHT_SMALL_VIEWPORT}px)`,
  [MediaQueries.mdAndUp]: {
    height: `calc(100% - ${NAV_MAX_HEIGHT}px)`,
  },
});

export const modalCss = {
  zIndex: 9,
};
